import React from "react";
import HeroBanner from "../components/MediaFolder/HeroBanner";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Recent from "../components/MediaFolder/Recent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
const Media = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <HeroBanner />
        <div className={classes.root}>
          <h2>hello</h2>
          <AppBar position="static">
            <Tabs
              style={{
                background: "#20B8EB",
                paddingLeft: "50px",
              }}
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Recent" {...a11yProps(0)} />
              <Tab label="Blog" {...a11yProps(1)} />
              <Tab label="Events" {...a11yProps(2)} />
              <Tab label="News" {...a11yProps(3)} />
              <Tab label="Gallery" {...a11yProps(4)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Recent />
          </TabPanel>
          <TabPanel value={value} index={1}>
            Blog
          </TabPanel>
          <TabPanel value={value} index={2}>
            News
          </TabPanel>
          <TabPanel value={value} index={3}>
            Events
          </TabPanel>
          <TabPanel value={value} index={4}>
            Gallery
          </TabPanel>
        </div>
      </div>
    </>
  );
};

export default Media;
